import { Slot, SlotFrameMode } from '@bcraft-frontend-lib/slots'

import { SLOTS_GAME_IDS } from 'router/routes'

import { getPureGameId } from 'modules/SlotsRoot/providersData/GameCatalog/uniqGameId'

const LEGACY_EXTERNAL_ID_TO_SLOT_ID: Record<string, number> = {
  aviator_spribe: SLOTS_GAME_IDS.AVIATOR,
}

const normalizeLegacyGameId = (legacyGameId: string) => legacyGameId.trim().toLowerCase()

export const resolveLegacySlotId = (legacyGameId: string, slots: Slot[] = []): number | null => {
  const normalizedLegacyGameId = normalizeLegacyGameId(legacyGameId)

  if (/^\d+$/.test(normalizedLegacyGameId)) {
    return Number(normalizedLegacyGameId)
  }

  const mappedSlotId = LEGACY_EXTERNAL_ID_TO_SLOT_ID[normalizedLegacyGameId]

  if (mappedSlotId) {
    return mappedSlotId
  }

  const matchedByExternalId = slots.find(slot => {
    const externalId = slot.externalId.toLowerCase()
    const pureGameId = getPureGameId(slot.externalId).toLowerCase()

    return (
      externalId === normalizedLegacyGameId ||
      pureGameId === normalizedLegacyGameId ||
      externalId.includes(`id:${normalizedLegacyGameId}`)
    )
  })

  if (matchedByExternalId) {
    return matchedByExternalId.id
  }

  const legacyParts = normalizedLegacyGameId.split('_').filter(Boolean)

  if (legacyParts.length >= 2) {
    const matchedByParts = slots.find(slot => {
      const externalId = slot.externalId.toLowerCase()
      const name = slot.name.toLowerCase()

      return legacyParts.every(part => externalId.includes(part) || name.includes(part))
    })

    if (matchedByParts) {
      return matchedByParts.id
    }
  }

  return null
}

export const resolveLegacySlotMode = (suffix?: string): SlotFrameMode => {
  if (!suffix) {
    return 'money'
  }

  const normalizedSuffix = suffix.toLowerCase()

  if (normalizedSuffix.includes('demo')) {
    return 'demo'
  }

  if (normalizedSuffix.includes('free') || normalizedSuffix.includes('freespin')) {
    return 'free-spin'
  }

  return 'money'
}

export const isLegacySlotSection = (sectionId: string) => sectionId !== 'frame'
